import React from "react";
import Link from "next/link";
// Modal
import IconButton from "@material-ui/core/IconButton";
import ShareIcon from "@material-ui/icons/Share";
import ShareModal from "components/modal/ShareModal";
import Tooltip from "@material-ui/core/Tooltip";

import UserPhoto from "components/UserPhoto";
import UserName from "components/UserName";
import UserUid from "components/UserUid";

const CardAppDevelopmentInfo = ({ appId, email, createdAt, handleOpen, open, handleClose, appName, oneLineContent }) => {
  /* 사용자 프로필 가져오기 */
  const photoUrl = UserPhoto(email);
  const name = UserName(email);
  const userUid = UserUid(email);

  return (
    <div className="flex items-center justify-between p-3 market-card-footer">
      <Link
        href={{
          pathname: "/user/profile/[id]",
          query: {
            id: userUid,
          },
        }}
      >
        <div className="flex justify-start items-center whitespace-pre-line break-all">
          <div>
            <div className="img-cover-box w-11 h-11 rounded-full bg-white border-2 border-white">
              <img src={photoUrl} alt="profile" />
            </div>
          </div>
          <div className="ml-2">
            <p className="truncate-1-lines mb-0 text-black font-gmarket-medium text-sm">{name}</p>
            <p className="mb-0 text-333 font-gmarket-medium text-xs">{createdAt.substring(0, 16)}</p>
          </div>
        </div>
      </Link>
      <div>
        <Tooltip title="공유하기">
          <IconButton color="primary" onClick={handleOpen}>
            <ShareIcon className="text-black" />
          </IconButton>
        </Tooltip>
        <ShareModal open={open} handleClose={handleClose} path={`/user/market/${appId}`} title={appName} description={oneLineContent} />
      </div>
    </div>
  );
};

export default CardAppDevelopmentInfo;
